import React from "react";
import Navbar from "../components/Sidebar/SidenavBar";
import Header from "../components/Header/header";
import { AppShell } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";

const Home = ({ page }) => {
  const [opened, { toggle }] = useDisclosure(false);

  return (
    <AppShell
      padding="sm"
      navbar={<Navbar opened={opened} toggle={toggle} />}
      header={<Header opened={opened} toggle={toggle} />}
      styles={(theme) => ({
        main: {
          backgroundColor:
            theme.colorScheme === "dark"
              ? theme.colors.dark[8]
              : theme.colors.gray[0],
        },
      })}
    >
      {page}
    </AppShell>
  );
};
export default Home;
